module.exports = __webpack_public_path__ + "static/media/box.6b8e995a.svg";